import File from "@tanker/file-ponyfill";
import { FocusSDK } from ".";
// import matchAll from "string.prototype.matchall";

async function matchAllFun() {
  const { default: matchAll } = await import("string.prototype.matchall");
  // eslint-disable-next-line
  String.prototype.matchAll = function (arg: RegExp) {
    return matchAll(this as string, arg);
  };
}

try {
  const nonRegexStr = /[ac]/g;
  "".matchAll(nonRegexStr);
} catch (e) {
  matchAllFun();
}

window.File = File;

(function (t: any) {
  function e() {
    const e: any = window || self;
    e.globalThis = e;
    delete t.prototype._T_;
  }
  "object" !== typeof globalThis &&
    (window
      ? e()
      : t.defineProperty(t.prototype, "_T_", {
          configurable: !0,
          get: e
        }));
})(Object);
